import { ZodObject, ZodIntersection } from 'zod/v4'

const schemaToTypeGuard = (schema: ZodObject<{ props: ZodIntersection }>) => ({
  guard: (props: unknown) => schema.shape.props.safeParse(props).success
})

export default schemaToTypeGuard
